/* eslint-disable header/header */
export const name = "@azure/msal-browser";
export const version = "4.21.1";
